import React from 'react';
import { Button, Grid, Typography } from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import { UploadFileIcon } from "../Icons";

const FileUploadUI = ({
    condition,
    upload,
    selectedFileName,
    handleFileUpload,
    handleDragOver,
    handleDrop,
    handleFileSelectChange
}) => (
    <Button
        component={!condition ? "label" : "div"}
        htmlFor={!condition ? "fileInput" : undefined}
        onClick={!condition ? handleFileUpload : undefined}
        onDragOver={!condition ? handleDragOver : undefined}
        onDrop={!condition ? handleDrop : undefined}
        style={{
            width: "100%",
            height: "132px",
            marginBottom: "8px",
            border: "1px dashed #2c3345",
            borderRadius: "4px",
            backgroundColor: "#fbfcff"
        }}
    >
        <Grid
            width={"100%"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            gap={"8px"}
        >
            {!condition && (
                <input
                    type="file"
                    id="fileInput"
                    style={{ display: "none" }}
                    onChange={handleFileSelectChange}
                    accept=".zip, .pdf, image/*, video/*"
                />
            )}
            {upload ? (
                <FolderIcon fontSize="large" style={{ color: "green", width: "50px", height: "50px" }} />
            ) : (
                <>
                    <UploadFileIcon />
                    <Typography variant="h4" color="#2c3345" fontWeight={700} style={{ fontFamily: 'sans-serif' }}>
                        Browse Files
                    </Typography>
                    <Typography variant="h6" color="#57647e" fontWeight={500} style={{ fontFamily: 'sans-serif' }}>
                        Drag and drop files here
                    </Typography>
                </>
            )}
            {selectedFileName && (
                <Grid display={'flex'} alignItems={'center'} justifyContent={'center'} gap={'12px'}>
                    <Typography variant="subtitle1" color="#57647e" style={{ fontFamily: 'sans-serif' }}>
                        {selectedFileName}
                    </Typography>
                </Grid>
            )}
        </Grid>
    </Button>
);

export default FileUploadUI;
